"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const saga_1 = require("@containers/common/model/saga");
const saga_2 = require("@containers/DF0001/model/saga");
const effects_1 = require("redux-saga/effects");
function* rootSaga() {
    yield (0, effects_1.all)([(0, saga_1.MainSaga)(), (0, saga_2.MainSaga)()]);
}
exports.default = rootSaga;
